"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Filter_1 = require("../../components/Filter");
var Filter = function () {
    var _a = (0, react_1.useState)(false), showFilterModal = _a[0], setShowFilterModal = _a[1];
    var onToggleShowFilterModal = (0, react_1.useCallback)(function () {
        setShowFilterModal(function (value) { return !value; });
    }, [setShowFilterModal]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Filter_1.FilterButton, { onClick: onToggleShowFilterModal }),
        showFilterModal && (react_1.default.createElement(Filter_1.FilterModal, { onClose: onToggleShowFilterModal }))));
};
exports.default = Filter;
